import {axiosAjax} from "src/request/index";

export function qryAddressList(data, apiHost) {
  return axiosAjax('https://mallmdotest.sgsonline.com.cn/' + 'ticMember/user/address/list', data)
}

export function saveAddress(data, apiHost) {
  return axiosAjax('https://mallmdotest.sgsonline.com.cn/' + 'ticMember/user/address/save', data)
}

export function delAddress(data, apiHost) {
  return axiosAjax('https://mallmdotest.sgsonline.com.cn/' + 'ticMember/user/address/del', data)
}

export function qryInvoiceList(data, apiHost) {
  return axiosAjax('https://mallmdotest.sgsonline.com.cn/' + 'ticMember/user/invoice/list', data)
}

export function saveInvoice(data, apiHost) {
  const url = data.isEdit ? 'https://mallmdotest.sgsonline.com.cn/' + 'ticMember/user/invoice/mod' : 'https://mallmdotest.sgsonline.com.cn/' + 'ticMember/user/invoice/add'
  return axiosAjax(url, data)
}

export function delInvoice(data, apiHost) {
  return axiosAjax('https://mallmdotest.sgsonline.com.cn/' + 'ticMember/user/invoice/del', data)
}

export function getCust(data, apiHost) {
  return axiosAjax('https://mallmdotest.sgsonline.com.cn/' + 'ticMember/cust/info/search', data)
}

export function getDownUrl(data, apiHost) {
  return axiosAjax('https://mallmdotest.sgsonline.com.cn/' + 'ticCenter/platform/fileUpload/getDownUrl', data)
}

export function checkTaxNo(data, apiHost) {
  return axiosAjax('https://mallmdotest.sgsonline.com.cn/' + 'ticMember/business/user/invoice/checkTaxNo', data)
}

export function GetCityList(data, apiHost) {
  return axiosAjax('https://mallmdotest.sgsonline.com.cn/' + 'ticCenter/center/org/qryOrgTree', data)
}

export function qryOrgTree(data, apiHost) {
  return axiosAjax('https://mallmdotest.sgsonline.com.cn/' + 'ticCenter/center/org/qryOrgTree', data)
}

export function qryBuLine(data, apiHost) {
  return axiosAjax('http://localhost:5001/' + 'ticCenter/center/basic/qryLineList', data)
}

export function checkCompany(data, apiHost) {
  return axiosAjax('http://localhost:5001/' + 'ticMember/cust/info/checkCompany', data)
}

export function qryLabByLabCode(data, apiHost) {
  return axiosAjax('http://localhost:5001/' + 'ticMember/oiq/application/qryLabByLabCode', data)
}